import { render, staticRenderFns } from "./ContactSummary.vue?vue&type=template&id=68def1a1&"
import script from "./ContactSummary.vue?vue&type=script&lang=js&"
export * from "./ContactSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports